import { render } from "./ProfileRubrics.vue?vue&type=template&id=b9079d6a&scoped=true"
import script from "./ProfileRubrics.vue?vue&type=script&lang=js"
export * from "./ProfileRubrics.vue?vue&type=script&lang=js"

import "./ProfileRubrics.vue?vue&type=style&index=0&id=b9079d6a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9079d6a"]])

export default __exports__